export default "__VITE_ASSET__CN5gAMu2__"